import { oz } from '@weft/utils';
import { DynamicInvoiceMeasurementChartMeterSchema } from './dynamic-invoice-measurement-chart-meter-schema';

export const DynamicInvoiceMeasurementChartDataSchema = oz.record(DynamicInvoiceMeasurementChartMeterSchema).openapi('DynamicInvoiceMeasurementChartData');

export type DynamicInvoiceMeasurementChartData = oz.infer<typeof DynamicInvoiceMeasurementChartDataSchema>;